import { useLocation } from "react-router-dom";
import { useEffect, useState } from "react";
import queryString from "query-string";
import { setChangedParam } from "./URLUtils";

/**
 * Hook, welcher Veränderungen eines Parameters in der Location propagiert.
 * @param paramName Der Name des Parameters
 * @param paramType Der Typ des Parameters (siehe Konstanten der URLUtils).
 * @param missingValue Der Wert, welcher ausgegeben werden soll, wenn der Parameter keinen gültigen Wert hat
 * @returns den Wert des Parameters
 */
function useQueryParam(paramName, paramType = null, missingValue = null) {
    const location = useLocation();

    const [paramValue, setParamValue] = useState(missingValue);

    useEffect(() => {
        setChangedParam(queryString.parse(location.search)[paramName], paramType, missingValue, paramValue, setParamValue);
    }, [location, paramName, paramValue, missingValue, paramType]);

    return paramValue;
}

export default useQueryParam;
